import styled from 'styled-components';

export const TextEditorStyled = styled.div<{ hasError: boolean }>`
  .rsw-toolbar {
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    padding: 4px;
    justify-content: flex-start;
    gap: 4px;
    flex-wrap: wrap;
  }
  .rsw-btn {
    padding: 4px 12px;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(204, 204, 204);
    border-radius: 4px;
    cursor: pointer;
    width: unset;
    height: unset;
  }
  .rsw-ce {
    background-color: ${({ hasError }) => (hasError ? '#fee' : '#fff')};
  }
  .rsw-editor {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-color: ${({ hasError }) => (hasError ? '#fd7d7d' : '#ddd')};
  }
  .rsw-ce.rsw-html {
    color: #ccc;
    background-color: #222;
    font-family: Menlo, Monaco, monospace, sans-serif;
  }

  .rsw-btn[title='HTML mode'] {
    padding: 4px !important;
  }

  .fn-btn {
    padding: 4px 6px;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
  }
`;
